// components/ManagerTimeOffList.tsx
import React, { useState } from "react";

import RequestHistory from "./RequestHistory";
import AdminRequestsPanel from "./AdminRequestsPanel";
import { Nav, Tab, Button } from "react-bootstrap";
import NewAdminRequestModal from "../../adminRequestsTab/NewAdminRequestModal";

interface TimeOffRequest {
    id: number;
    userId: string;
    timeOffStartDate: string;
    timeOffEndDate: string;
    typeOfLeave: string;
    comment?: string;
    isApproved: boolean;
    isRejected: boolean;
}

const ManagerRequest: React.FC = () => {
    // const [activeTab, setActiveTab] = useState("admin-request");
    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    // const handleSelect = (selectedKey: any) => {
    //     setActiveTab(selectedKey);
    // };
    return (
        <>
            {/* <div className="common_card"> */}
            {/* <Tab.Container
                    id="admin-tabs"
                    activeKey={activeTab}
                    onSelect={handleSelect}
                >
                    <div className="tab_flx">
                        <Nav variant="pills" className="common_tab">
                            <Nav.Item>
                                <Nav.Link eventKey="admin-request">Admin Request</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="request-history">Request History</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>

                    <Tab.Content>
                        <Tab.Pane eventKey="admin-request">
                            <div className="top border_tittle top_bar_flx mby_16">
                                <div className="top_bar_tittle">
                                    <h2>Admin Requests</h2>
                                </div>
                                <div className="top_right_flx">
                                    <Button onClick={handleShow} variant="primary" className="btn_sm">
                                        Add New Request
                                    </Button>
                                </div>
                            </div>
                            <AdminRequestsPanel />
                        </Tab.Pane>

                        <Tab.Pane eventKey="request-history">
                            {
                                activeTab == "request-history" && <RequestHistory />

                            }
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container> */}
            {/* {show &&
                    <NewAdminRequestModal
                        handleClose={handleClose}
                        show={show}
                    />
                } */}
            {/* </div> */}
            <AdminRequestsPanel />


        </>
    );
};

export default ManagerRequest;
